// extracted by mini-css-extract-plugin
export default {"btn":"Scroll_btn__BjF5j","Mobbtn":"Scroll_Mobbtn__+NKrl","Tabbtn":"Scroll_Tabbtn__2g-Uh","icon":"Scroll_icon__5hDpF","icon2":"Scroll_icon2__F2nA8","hover":"Scroll_hover__fKFRn"};